import mapboxgl from 'mapbox-gl';

/**
 * @region private objects to track the layers and sources
 */
let _map = null;
let _parent = null;
let _popups = {};
let _defaultPopupKey = 'default';
/**
 * @endregion
 */

/**
 * private functions
 */
const methods = {
    setPopupCoordinates: (id, coordinates) => {
        if (_popups[id]) {
            if (coordinates && coordinates.length > 1) {
                _popups[id].setLngLat(coordinates);
            }
        }
    },
    setPopupContent: (id, content) => {
        if (_popups[id]) {
            if (content) {
                if (typeof content == "string")
                    _popups[id].setHTML(content);
                else
                    _popups[id].setDOMContent(content);
            }
        }
    },
    setPopupComponent: (id, component) => {
        if (_popups[id]) {
            if (component) {
                _popups[id].setHTML(`<div id="popup_${id}"></div>`);
                component.$mount(`#popup_${id}`);
                _popups[id]._update();
            }
        }
    }
};

/**
 * the popup factory
 */
const popupFactory = {
    initialise: (map, parent) => {
      _map = map;
      _parent = parent;
    },
    getPopup: (options) => {
        options = options || {};
        let id = options.id || _defaultPopupKey;

        let coordinates = options.coordinates || [];
        let content = options.content || null;
        let component = options.component || null;

        let popupOptions = {
            closeButton: options.closeButton || false,
            closeOnClick: options.closeOnClick || false,
            anchor:'bottom'
        };

        if(!!options.className){
            popupOptions.className = options.className;
        }
        if(!!options.maxWidth){
            popupOptions.maxWidth = options.maxWidth;
        }
        if(!!options.offset){
            popupOptions.offset = options.offset;
        }

        if (!_popups[id]) {
            _popups[id] = new mapboxgl.Popup(popupOptions);
        }
        methods.setPopupCoordinates(id, coordinates);
        methods.setPopupContent(id, content);
        return _popups[id];
    },
    show: (options) => {
        let popup = popupFactory.getPopup(options);
        popup.addTo(_map);
    },
    hide: (id) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            _popups[id].remove();
        }
    },
    hideAll: () => {
        if(!!_popups) {
            _.forOwn(_popups,popup => {
                popup.remove();
            });
        }
    },
    isOpen: (id) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            return _popups[id].isOpen();
        }
        return false;
    },
    remove: (id) => {
        id = id || _defaultPopupKey;
        popupFactory.hide(id);
        if (_popups[id]) {
            delete _popups[id];
        }
    },
    addClassName: (id, className) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            _popups[id].addClassName(className);
        }
    },
    removeClassName: (id, className) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            _popups[id].removeClassName(className);
        }
    },
    toggleClassName: (id, className) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            _popups[id].toggleClassName(className);
        }
    },
    trackPointer: (id) => {
        id = id || _defaultPopupKey;
        if (_popups[id]) {
            _popups[id].trackPointer();
        }
    }
};
export default popupFactory;